import ComponentLayout from "../../../../src/layouts/component-layout";
import { Label } from '@primer/react';
import { BreadcrumbVariants } from '@primer/react-brand';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  ComponentLayout,
  Label,
  BreadcrumbVariants,
  PropTableValues,
  React
};